import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'gstar-client-selection-modal',
  templateUrl: './client-selection-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClientSelectionModalComponent {
  modalId = 'client-modal';
  title = input.required<string>();
  description = input.required<string>();
}
